module.exports = __webpack_public_path__ + "img/bg.45e04de6.jpg";